<app-theader></app-theader>

<div class="mainrow  finzy-container-padding-bottom col-md-12">
	<div  class="col-md-12 finzy-container-padding-2" style="text-align: center;padding: 100px 0;">		
		<i class="material-icons" style="text-align: center;color: #4db53e;font-size: 100px;">check_circle</i>
		<h3 style="margin-right: auto;margin-left: auto;text-align:center;font-family: Lato;color: #6c6c6c;">Link Generated Successfully</h3>
		<p style="color: #6c6c6c;font-size: 15px;margin-top: 20px;letter-spacing: 1.3px;">Please find the URL to complete loan application registration below</p>

		<p style="color: #0d3ab3;
    padding: 20px 30px;
    margin-top: 30px;
    background-color: #eee;
    margin-bottom: 50px;
    width: 400px;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;">{{shortURL}}</p>
	</div>
</div>

<app-tfooter></app-tfooter>